import mammoth from "mammoth";
import { FC, useEffect, useState } from "react";
import { isWordFileByExtension } from "../../../../../../../../modules/filestore/utils/FileUtil";
import FileViewerHTML from "../FileViewerHTML";

const CLASSNAME = "file-viewer-word";

export type FileViewerWordProps = {
  blob: Blob | undefined;
  fileExtension: string | undefined;
  fileName: string | undefined;
};

const FileViewerWord: FC<FileViewerWordProps> = ({
  blob,
  fileExtension,
  fileName,
}) => {
  const [htmlContent, setHTMLContent] = useState<string>();

  useEffect(() => {
    if (isWordFileByExtension(fileExtension)) {
      blob
        ?.arrayBuffer()
        .then((arrayBuffer) =>
          mammoth.convertToHtml({
            arrayBuffer,
          })
        )
        .then(({ value }) => setHTMLContent(value));
    }
  }, [blob, fileExtension]);

  return (
    <div className={CLASSNAME}>
      <FileViewerHTML
        htmlContent={htmlContent}
        errorMessage={`Failed to load file ${fileName}`}
      />
    </div>
  );
};

export default FileViewerWord;
